export const locale = {
  lang: 'en',
  data: {
    'TOOLBAR': {
      'USER': {
        'PROFILE': 'My profile',
        'EXIT': 'Exit'
      },
      'LOGOUT': {
        'CONFIRM': 'Confirm',
        'MESSAGE': 'Are you sure you want to exit from the application?',
        'CANCEL': 'Cancel',
        'EXIT': 'Exit from the application'
      }
    },
    'START_ONBOARDING': 'Start',
    'RESUME_ONBOARDING': 'Resume'
  }
};
